import { Component } from '@angular/core';
import { DialogParams } from './dialog-base.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomainService } from './domain.service';

export interface ValidationSaveErrorsDialogParams extends DialogParams {
  entityErrors: any;
}

@Component({
    templateUrl: './validation-save-errors-dialog.component.html',
    standalone: false
})
// cannot inherit from DialogBaseComponent because this component has initialization issues with the dbSaveService where
// this component is used.  So we have to handle initialization differently in this one case. 
export class ValidationSaveErrorsDialogComponent  {
  isPageReady = false;
  params: ValidationSaveErrorsDialogParams;
  constructor( public config: DynamicDialogConfig<ValidationSaveErrorsDialogParams>, public dialogRef: DynamicDialogRef,
      public domainService: DomainService) {
      this.params = config.data;
      this.isPageReady = true;
    }

  close() {
    this.dialogRef.close();
  }
}
